export const NULL_VALUE = '--';
